// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SmallTalkUserSays__smallTalkUserSays___2CJ2R{width:50%;min-width:50%;padding:16px;box-sizing:border-box;overflow-y:auto}.SmallTalkUserSays__smallTalkUserSaysHeader___16OZz{display:flex;align-items:center;font-size:12px;color:#777;margin-bottom:16px}.SmallTalkUserSays__smallTalkUserSaysHeaderIcon___2Rz-H{width:24px;height:24px;margin-right:8px;margin-left:-2px;opacity:0.5}.SmallTalkUserSays__smallTalkUserSaysBody___3byPM{flex:1}.SmallTalkUserSays__smallTalkUserSaysSentence___1j57y{color:#333;font-weight:400;font-size:14px;padding:10px 0px}\n", ""]);
// Exports
exports.locals = {
	"smallTalkUserSays": "SmallTalkUserSays__smallTalkUserSays___2CJ2R",
	"smallTalkUserSaysHeader": "SmallTalkUserSays__smallTalkUserSaysHeader___16OZz",
	"smallTalkUserSaysHeaderIcon": "SmallTalkUserSays__smallTalkUserSaysHeaderIcon___2Rz-H",
	"smallTalkUserSaysBody": "SmallTalkUserSays__smallTalkUserSaysBody___3byPM",
	"smallTalkUserSaysSentence": "SmallTalkUserSays__smallTalkUserSaysSentence___1j57y"
};
module.exports = exports;
